import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

export const getNotAccepted = (projectVersionId, projectReviewerId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/review-reject/`
  return doGet(url)
}

export const saveNotAccepted = (request) => {
  const url = `${API_ROOT}/review/review-reject`
  return doPost(url, request)
}
